module.exports = __webpack_public_path__ + "img/competencies_rd_video_02.a052ac95.jpg";